module.exports = __webpack_public_path__ + "assets/img/7_337_big.52ba84ee.jpg";